import { Link, Text, TextBlock, NewLine, Heading } from "../atoms/TextContainers"
import { BaseContainer, TextContainer, TimedContainer, Blockquote, ParallelContainer } from "../atoms/ContentContainers"
import { Centered, Normal, HorizontalRow } from "../atoms/Arrangement"
import { UnorderedList, OrderedList, ListElement } from "../atoms/List"
import { Image, ImageInText, ImageLink } from "../atoms/Image"
import FileDownload from "../atoms/FileDownload"
import { Embed } from "../atoms/Embed"
import AutoGallery from "../atoms/AutoGallery"

const PageMapper = ({ data }) => (
    <>
        {data.map((item, i) => (
            <AtomRenderer key={i} data={item} />
        ))}
    </>
);

function AtomRenderer({ data }) {
    switch (data.type) {
        case "text":
            return <Text content={data.content} text={data.text} bold={data.bold || false} opacity={data.opacity} />;
        case "textBlock":
            return <TextBlock text={data.text} />;
        case "link":
            return <Link text={data.text} destination={data.destination} newTab={data.newTab || false} bold={data.bold || false} />;
        case "newLine":
            return <NewLine />;
        case "heading":
            return <Heading text={data.text} topSpace={data.topSpace || 0.7} type={data.level || 1} />;
        case "baseContainer":
            return <BaseContainer><PageMapper data={data.content} /></BaseContainer>;
        case "textContainer":
            return <TextContainer maxWidthEM={data.maxWidthEM}><PageMapper data={data.content} /></TextContainer>;
        case "timedContainer":
            return <TimedContainer startDisplay={data.startDisplay} endDisplay={data.endDisplay}><PageMapper data={data.content} /></TimedContainer>;
        case "blockquote":
            return <Blockquote><PageMapper data={data.content} /></Blockquote>;
        case "parallelContainer":
            return <ParallelContainer><PageMapper data={data.content} /></ParallelContainer>;
        case "horizontalRow":
            return <HorizontalRow blue={data.blue || false} />;
        case "centered":
            return <Centered><PageMapper data={data.content} /></Centered>;
        case "normal":
            return <Normal><PageMapper data={data.content} /></Normal>;
        case "unorderedList":
            return <UnorderedList><PageMapper data={data.content} /></UnorderedList>;
        case "orderedList":
            return <OrderedList><PageMapper data={data.content} /></OrderedList>;
        case "listElement":
            return <ListElement><PageMapper data={data.content} /></ListElement>;
        case "image":
            return (
                <Image
                    src={process.env.REACT_APP_CDN_URL + data.src}
                    width={data.width || 90}
                    maxWidth={data.maxWidth || 50}
                    alt={data.alt || ""}
                    caption={data.caption || ""}
                    centered={data.centered || false}
                />
            );
        case "imageInText":
            return (
                <ImageInText
                    src={process.env.REACT_APP_CDN_URL + data.src}
                    align={data.align}
                    alt={data.alt || ""}
                    caption={data.caption || ""}
                />
            );
        case "imageLink":
            return (
                <ImageLink
                    src={process.env.REACT_APP_CDN_URL + data.src}
                    width={data.width || 90}
                    maxWidth={data.maxWidth || 50}
                    alt={data.alt || ""}
                    caption={data.caption || ""}
                    centered={data.centered || false}
                    destination={data.destination || ""}
                    newTab={data.newTab !== false}
                />
            );
        case "fileDownload":
            return (
                <FileDownload
                    src={process.env.REACT_APP_CDN_URL + data.src}
                    label={data.label || ""}
                />
            );
        case "embed":
            return <Embed src={data.src} width={data.width} height={data.height} center={data.center || false} />;
        case "autoGallery":
            return <AutoGallery src={data.src} inverted={data.inverted || false} />;
        case "newsContainer":
            return <><PageMapper data={data.content} /></>;
        default:
            return <Text text={`Der Typ "${data.type}" existiert nicht.`} />;
    }
}

export default PageMapper;
